import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="top-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6">
        <div
          className={`flex items-center justify-between rounded-full px-5 md:px-7 py-3 transition-all ${
            scrolled ? "glass shadow-lg" : "bg-transparent"
          }`}
        >
          <button
            onClick={() => scrollTo("hero")}
            className="flex items-center"
            data-testid="brand-logo"
          >
            <img
              src="/brand/volotag-logo-cropped.png"
              alt="VoloTag"
              className="h-9 md:h-11 w-auto rounded-lg"
            />
          </button>

          <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-600">
            <button data-testid="nav-product" onClick={() => scrollTo("product")} className="hover:text-black transition">Product</button>
            <button data-testid="nav-interaction" onClick={() => scrollTo("interaction")} className="hover:text-black transition">See it respond</button>
            <button data-testid="nav-how" onClick={() => scrollTo("how")} className="hover:text-black transition">How it works</button>
            <button data-testid="nav-stories" onClick={() => scrollTo("stories")} className="hover:text-black transition">Stories</button>
            <button data-testid="nav-faq" onClick={() => scrollTo("faq")} className="hover:text-black transition">FAQ</button>
          </nav>

          <Button
            data-testid="nav-cta"
            onClick={() => scrollTo("waitlist")}
            className="rounded-full bg-black hover:bg-zinc-900 text-white px-5 h-10 cta-shine shadow-[0_8px_24px_-8px_rgba(0,0,0,0.4)]"
          >
            Join Waitlist
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Nav;
